// Utils
import { toLocaleString } from "../../../common-utils/string-utils/StringUtils";
import { constructLineChartData } from "../../../utils/ChartUtils";

// Components
import { LineChart } from "../../../components/charts/Charts";

// Stretch Metrics Info And Chart
export default function StretchMetricsInfoAndChart({ stretchMetrics }) {
  const { dailyData = [], otsLitAvg } = stretchMetrics || {};

  // If No-Data
  if (Object.keys(stretchMetrics).length === 0 || dailyData.length < 1) {
    return null;
  }

  // to get last value of an array
  const cumulativeValue = dailyData.at(-1);
  const { cumulativeReach, cumulativeFrequency } = cumulativeValue || {};

  const stretchInfo = [
    {
      label: "Start Date:",
      value: "29 Dec 2025",
    },
    {
      label: "End Date:",
      value: "25 Jan 2026",
    },
    {
      label: "Duration:",
      value: "15 Days",
    },
    {
      // .toFixed returns string value and toLocaleString will accept the number format
      // so again converting toFixed value as a number by add plus sign
      label: "Estimated Reach:",
      value: toLocaleString(+cumulativeReach?.toFixed()),
    },
    {
      label: "Cumulative Frequency:",
      value: toLocaleString(+cumulativeFrequency?.toFixed(4)),
    },
    {
      label: "Impressions:",
      value: toLocaleString(Math.ceil(cumulativeReach * cumulativeFrequency)),
    },
  ];

  // Chart Data
  const lineChartData = constructLineChartData(dailyData);
  const linesData = [
    {
      type: "linear",
      dataKey: "Total Unique Devices",
    },
  ];

  return (
    <>
      <div className="d-flex pt-4">
        <div className="col-5 px-0">
          <p className="font-weight-bold">
            {`Monthly Impressions (${toLocaleString(otsLitAvg)})`}
          </p>

          {/* stretch Info */}
          <div className="table-responsive">
            <table className="table table-sm">
              <tbody>
                {stretchInfo.map((info, i) => (
                  <tr key={i}>
                    <td className="col-6 pl-3">
                      <p>{info.label}</p>
                    </td>
                    <td className="col-6 pl-3">
                      <p className="font-weight-bold">{info.value}</p>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>

        {/* Chart */}
        <div className="col-7">
          <LineChart
            data={lineChartData}
            linesData={linesData}
            xAxisLabel="Days No."
            yAxisLabel="Total Unique Devices"
          />
        </div>
      </div>
      <hr className="divider row"></hr>
    </>
  );
}
